<template>
  <div class="circle-popup">
    <table class="table table-sm table-bordered">
      <tr><td>speed</td><td>{{ data.speed }}</td></tr>
      <tr><td>time</td><td>{{ data.time }}</td></tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  }
};
</script>